var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infographics-block"},[_c('eyecatch'),_c('div',{staticClass:"infographics-wrap"},[_c('data-block'),_c('locus'),_c('in-future')],1),_c('footer-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }